
import Vue from 'vue'
import type { IArticleItem } from 'blog'
import SvgIcon from '@/components/svgIcon/index.vue'

import { faEye, faCalendar, faComment } from '@fortawesome/free-regular-svg-icons';
import { icon } from '@fortawesome/fontawesome-svg-core';
const res = Vue.extend({
	props: {
		content: {
			default: () => ({
				id: '123',
				thumb: '',
				title: '回书义常且音',
				createDate: '2009-8-29',
				scanNumber: 2278,
				commentNumber: 78,
				category: {
					id: '1',
					name: '分类1'
				},
				description: '同空能京南进安西完再支风飞严领光。得生这局月确位军们离存电。热建子光验复更度合确验前切声。'

			} as Partial<IArticleItem>)
		},
		handleClickTitle: {
			default: () => ((id: string) => {

			})
		}
	},
	components: {
		SvgIcon
	},
	computed: {
		date: () => faCalendar,
		view: () => faEye,
		comment: () => faComment
	}

})

export default res
